import {
	Group,
	type GroupProps,
	Panel,
	type PanelProps,
	Separator,
	type SeparatorProps,
} from "react-resizable-panels";

import { cn } from "@/components/ui/lib/utils";

type ResizablePanelGroupProps = Omit<GroupProps, "orientation"> & {
	direction?: "horizontal" | "vertical";
};

function ResizablePanelGroup({
	className,
	direction = "horizontal",
	...props
}: ResizablePanelGroupProps) {
	return (
		<Group
			data-slot="resizable-panel-group"
			data-panel-group-direction={direction}
			orientation={direction}
			className={cn(
				"flex h-full w-full data-[panel-group-direction=vertical]:flex-col",
				className,
			)}
			{...props}
		/>
	);
}

function ResizablePanel({ className, ...props }: PanelProps) {
	return (
		<Panel
			data-slot="resizable-panel"
			className={cn("overflow-hidden", className)}
			{...props}
		/>
	);
}

type ResizableHandleProps = Omit<SeparatorProps, "children"> & {
	withHandle?: boolean;
};

function ResizableHandle({ withHandle, className, ...props }: ResizableHandleProps) {
	return (
		<Separator
			data-slot="resizable-handle"
			className={cn(
				"bg-border relative flex w-1 cursor-col-resize items-center justify-center transition-colors hover:bg-primary/20 active:bg-primary/30",
				"data-[orientation=vertical]:h-1 data-[orientation=vertical]:w-full data-[orientation=vertical]:cursor-row-resize",
				"after:absolute after:inset-y-0 after:left-1/2 after:w-4 after:-translate-x-1/2",
				"data-[orientation=vertical]:after:inset-x-0 data-[orientation=vertical]:after:top-1/2 data-[orientation=vertical]:after:h-4 data-[orientation=vertical]:after:w-full data-[orientation=vertical]:after:-translate-y-1/2 data-[orientation=vertical]:after:translate-x-0",
				className,
			)}
			{...props}
		>
			{withHandle && (
				<div className="z-10 flex h-6 w-1 items-center justify-center rounded-sm bg-border" />
			)}
		</Separator>
	);
}

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
